import React, { useState } from "react";
import { Button, TextBox, ValidationGroup, Validator } from "devextreme-react";
import { EnvioEmailSMSActivacionCuenta } from "./actions";
import { envioEmailSMSActivacionCuenta } from "../../../services/ValidacionIdentidad";
import { phoneNumberInsert } from "../phoneNumberInsert";

/**
 * Renderiza la pantalla final de recuperacion de
 * contraseña y envio del codigo de recuperacion
 */
const RecuperacionPassword = ({
  titulo,
  descripcion,
  telefono,
  email,
  dispatch,
}) => {
  const [emailUsuario, setEmailUsuario] = useState(() => email);
  const [telefonoUsuario, setTelefonoUsuario] = useState(() => telefono);
  return (
    <>
      <center>
        <div className="acceso row">
          <div
            className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"
            style={{ margin: "5px 0" }}
          >
            <h2
              className="titulo-validacion-cuenta"
              style={{ textAlign: "center", paddingTop: 5 }}
            >
              {titulo}
            </h2>

            <p
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{ fontSize: "14px", fontWeight: "bolder" }}
            >
              {descripcion}
            </p>
          </div>
          <ValidationGroup>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Teléfono <span className="label-green-requerido">*</span>
                </p>
              </h3>
              <TextBox
                mask="+56\900000000"
                useMaskedValue
                placeholder="Teléfono"
                maxLength={30}
                valueChangeEvent="keyup"
                maskInvalidMessage="Teléfono inválido"
                onValueChanged={(e) => setTelefonoUsuario(phoneNumberInsert(e.previousValue, e.value))}
                value={telefonoUsuario}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Teléfono es requerido",
                    },
                  ]}
                />
              </TextBox>
            </div>
            <div className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>
                <p className="text-left">
                  Correo electrónico
                  <span className="label-green-requerido"> *</span>
                </p>
              </h3>
              <TextBox
                placeholder="ejemplo@email.com"
                onValueChanged={(e) => setEmailUsuario(e.value)}
                valueChangeEvent="keyup"
                maxLength={60}
                value={emailUsuario}
              >
                <Validator
                  validationRules={[
                    {
                      type: "required",
                      message: "Email es requerido",
                    },
                    {
                      type: "email",
                      message: "Email invalido",
                    },
                  ]}
                />
              </TextBox>
              <p className="input-information text-left">
                {`Recuerda registrar un correo electrónico y teléfono válido.
              Siempre puedes modificar tus datos en Mi cuenta > Mi perfil de ACHS
              Virtual.`}
              </p>
            </div>
            <div
              className="componentesLogin col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{ textAlign: "center", marginTop: "10px" }}
            >
              <Button
                //disabled={this.state.checkBox}
                text="Enviar codigo de verificación"
                style={{ width: "100%", marginTop: "10px" }}
                type="default"
                onClick={(e) => {
                  const result = e.validationGroup.validate();
                  result.isValid &&
                    dispatch(
                      EnvioEmailSMSActivacionCuenta(
                        {
                          Phone: telefonoUsuario,
                          Email: emailUsuario,
                          NotificationType: 3,
                        },
                        3,
                        envioEmailSMSActivacionCuenta
                      )
                    );
                }}
              />
            </div>
          </ValidationGroup>
        </div>
      </center>
    </>
  );
};

export default RecuperacionPassword;
